import React from 'react';
import {HttpInterceptors} from "@utils/HttpInterceptors";
import configureInterceptor = HttpInterceptors.configureInterceptor;
import {
    FlintNotificationContextProvider
} from "@components/page_components/common/notifications/FlintNotificationContext";
import {AuthenticationContextProvider} from "@utils/auth/AuthenticationContext";
import AppRouter from "./AppRouter";
import ErrorBoundary from "./utils/errors/ErrorBoundary";
import {FlintDialogContextProvider} from "@components/page_components/common/dialogs/FlintDialogContextProvider";
import {PiwikContext, PiwikContextProvider, usePiwikContext} from "@utils/tracking/PiwikContext";
import {VivoPopupContextProvider} from "@utils/popups/VivoPopupContext";
import {KendoLocalizationWrapper} from "@utils/kerndo_localization/KendoLocalizationWrapper";

configureInterceptor();

function App() {
    return (
        <div className="App">
            <KendoLocalizationWrapper>
                <FlintNotificationContextProvider>
                    <AuthenticationContextProvider>
                        <PiwikContextProvider>
                            <FlintDialogContextProvider>
                                <VivoPopupContextProvider>
                                    <AppRouter/>
                                </VivoPopupContextProvider>
                            </FlintDialogContextProvider>
                        </PiwikContextProvider>
                    </AuthenticationContextProvider>
                </FlintNotificationContextProvider>
            </KendoLocalizationWrapper>
        </div>
    );
}

export default App;
